import { useStore } from 'jotai';
import { useCallback } from 'react';

import { isCreateProjectDialogOpenState } from '@/project/states/isCreateProjectDialogOpenState';

export const useOpenCreateProjectDialog = () => {
  const store = useStore();

  const openCreateProjectDialog = useCallback(() => {
    store.set(isCreateProjectDialogOpenState.atom, true);
  }, [store]);

  return { openCreateProjectDialog };
};
